<div
  [class]="containerClass"
  dropdown
  (onHidden)="onHide()"
  (keydown)="onKeyPress($event, dropdown)"
  #dropdown="bs-dropdown"
  [insideClick]="true"
>
  <button
    dropdownToggle
    [class]="buttonClass"
    [class.is-invalid]="wrong"
    type="button"
  >
    <span
      class="dropdown-item dropdown-item-lender"
      [class]="spanClass"
      *ngIf="isMultipleValues; else Single"
    >
      <span class="align-img" *ngIf="values[0]?.image">
        <img [src]="values[0].image" alt="" class="mCS_img_loaded" />
      </span>
      <span *ngFor="let label of getLabels; let idx=index" (click)="removeItemFromList(label)">
        {{ label }}<ng-container *ngIf="getLabels.length > 1 && idx < getLabels.length-1">, </ng-container>
      </span>
    </span>
    <ng-template #Single>
      <span
        class="dropdown-item dropdown-item-lender"
        [class]="spanClass"
        *ngIf="!isMultipleValues && value?.[labelProp]; else placeholderRef"
      >
        <span class="align-img" *ngIf="value?.image">
          <img [src]="value.image" class="mCS_img_loaded" />
        </span>
        {{ value?.[labelProp] }}
      </span>
    </ng-template>
    <ng-template #placeholderRef>{{ placeholder }}</ng-template>
  </button>
  <div class="dropdown-menu dropdown-menu-lender show" *dropdownMenu>
    <span *ngIf="search"
      ><input
        type="text"
        class="form-control"
        placeholder="Search"
        [value]="searchText"
        (input)="searchInput($event)"
    /></span>

    <!-- [visibility]="'hover'" -->
    <ng-scrollbar 
      class="scroll-height mCustomScrollbar"
    >
      <div class="mCustomScrollBox mCS-dark-thin mCSB_vertical mCSB_inside">
        <div class="mCSB_container mCS_y_hidden mCS_no_scrollbar_y" dir="ltr">
          <span
            class="dropdown-item ng-star-inserted"
            *ngFor="let item of searchedItems"
            (click)="checkItem(item, dropdown)"
            [class.active]="item?.[valueProp] === value?.[valueProp]"
          >
            <span class="align-img" *ngIf="item?.image">
              <img [src]="item.image" alt="" class="mCS_img_loaded" />
            </span>
            {{ item?.[labelProp] }}
          </span>
        </div>
      </div>
    </ng-scrollbar>
    <!-- <div
      class="scroll-height mCustomScrollbar"
      malihu-scrollbar
      [scrollbarOptions]="{ theme: 'dark-thin' }"
    > -->

    <!-- </div> -->
  </div>
</div>
